<template>
  <div class="charts-wrap">
    <ul style="cursor: pointer">
      <li v-for="(item, index) in chartsData" @click="jumpCtc(item)">
        <div class="chart-box">
          <p>
            <span class="title2">{{ item.coinType }}</span>
            <!-- <span class="title2">{{ item.coinType }}/{{ item.unit }}</span> -->
            <span class="title3 ml20"
              >{{ item.up ? "+" : "" }}{{ item.range }}</span
            >
          </p>
          <p class="title1">
            <span>{{ item.price }}</span>
            <!-- <span class="ml10">USDT</span> -->
          </p>
        </div>
        <div class="charts-div" :ref="'home_charts_' + index"></div>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState } from "vuex";

// 引入 ECharts 主模块
let echarts = require("echarts/lib/echarts");

// 引入折线图/柱状图等组件
require("echarts/lib/chart/line");
// 引入提示框和title组件，图例
require("echarts/lib/component/tooltip");
require("echarts/lib/component/title");
require("echarts/lib/component/legend");
export default {
  name: "v-home-page-echarts",
  props: ["chartsData"],
  data() {
    return {
      klineUrl: "",
      timer: null,
      myChart: [],
    };
  },
  created() {
    this.klineUrl = "/api/v1/trade/spot/kline";
  },
  mounted() {
    let that = this;
    this.timer = setInterval(function () {
      that.drawLine();
    }, 10000);
  },
  updated() {
    this.drawLine();
  },
  destroyed() {
    clearInterval(this.timer);
  },
  methods: {
    jumpCtc(obj) {
      this.$router.push({
        path: "/ctc",
        query: { symbol: obj.coinType + "/" + obj.unit },
      });
    },
    drawLine() {
      let time = new Date().getTime() - 24 * 60 * 60 * 1000; //一天前时间戳
      let beginTime = parseInt((time / 1000).toString()); //转化为秒
      let that = this;
      for (let i = 0; i < this.chartsData.length; i++) {
        if (!this.myChart[i]) {
          this.myChart[i] = echarts.init(this.$refs["home_charts_" + i][0]);
        }
        this.getKlineData(
          this.chartsData[i].symbol,
          "5m",
          beginTime,
          function (serData) {
            that.chartsData[i].charts = serData;
            that.myChart[i].setOption({
              grid: {
                left: 0,
                top: "40%",
                height: "60%",
                width: "100%",
              },
              color: ["#42CB83"],
              xAxis: {
                show: false,
                type: "category",
                boundaryGap: false,
              },
              yAxis: {
                type: "value",
                show: false,
                min: "dataMin",
              },
              series: [
                {
                  data: that.chartsData[i].charts,
                  type: "line",
                  smooth: true,
                  areaStyle: {
                    color: {
                      type: "linear",
                      x: 0,
                      y: 0,
                      x2: 0,
                      y2: 1,
                      colorStops: [
                        {
                          offset: 0,
                          color: "#C1EED6", // 0% 处的颜色
                        },
                        {
                          offset: 1,
                          color: "rgba(255, 255, 255, 0)", // 100% 处的颜色
                        },
                      ],
                      global: false, // 缺省为 false
                    },
                  },
                  showSymbol: false,
                },
              ],
            });
          },
        );
      }
    },
    //获取echarts数据
    getKlineData(s, p, b, callback) {
      let paramUrl = this.klineUrl + "?s=" + s + "&p=" + p + "&b=" + b;
      this.$axios.get(paramUrl, {}).then((res) => {
        let that = this;
        if (res.data.code === this.errorCode.ok) {
          let serData = [];
          let resData = res.data.data;
          resData.forEach((value) => {
            let item = [];
            item.push(
              that.dateFormatter(new Date(value[0]), "yyyy/MM/dd hh:mm:ss"),
            );
            item.push(value[4]);
            serData.push(item);
          });
          callback(serData);
        }
      });
    },
  },
  computed: {
    ...mapState({
      user: "user",
      errorCode: "errorCode",
    }),
  },
};
</script>

<style lang="less" scoped>
.chart-box {
  #lineChartId {
    width: 100%;
    height: 100px;
    margin-top: 20px;
  }
  .title2 {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #333333;
  }
  .title3 {
    font-family: PingFang SC, PingFang SC;
    font-weight: 800;
    font-size: 16px;
    color: #5eba89;
  }
  .title1 {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 23px;
    color: #333333;
  }
}
.charts-wrap {
  width: 100%;
  ul {
    width: 100%;
    display: flex;

    li {
      flex: 1;
      border-left: 2px solid #eeeeee;
      position: relative;

      &:first-of-type {
        border-left: none;
      }
      .charts-div {
        height: 100%;
        height: 100px;
      }
    }
  }
}
</style>
